import type { CSSProperties } from "react";
import "./AnalysisFolder.css";

type TAnalysisFolderProps = {
  label: string;
  eta: string;
  accent?: string;
  scale?: number;
};

export function AnalysisFolder({ label, eta, accent = "#1F84A3", scale }: TAnalysisFolderProps) {
  const style = {
    "--af-accent": accent,
    ...(scale !== undefined ? { "--af-scale": String(scale) } : {})
  } as CSSProperties;

  return (
    <div className="af-stage" style={style} aria-hidden>
      <div className="af-tab" />
      <div className="af-back" />
      <div className="af-sheet" />

      <div className="af-doc" style={{ "--af-x": "-52px", "--af-r": "-9deg" } as CSSProperties}>
        <div className="af-line" style={{ width: "70%" }} />
        <div className="af-line" style={{ width: "100%" }} />
        <div className="af-line" style={{ width: "88%" }} />
      </div>
      <div className="af-doc" style={{ "--af-x": "48px", "--af-r": "11deg", animationDelay: "1.8s" } as CSSProperties}>
        <div className="af-line" style={{ width: "56%" }} />
        <div className="af-line" style={{ width: "96%" }} />
        <div className="af-line" style={{ width: "100%" }} />
      </div>
      <div className="af-doc" style={{ "--af-x": "-4px", "--af-r": "4deg", animationDelay: "3.6s" } as CSSProperties}>
        <div className="af-line" style={{ width: "64%" }} />
        <div className="af-line" style={{ width: "92%" }} />
        <div className="af-line" style={{ width: "78%" }} />
      </div>

      <div className="af-front">
        <span className="af-front-label">{label}</span>
        <span className="af-front-eta">{eta}</span>
      </div>
    </div>
  );
}
